import { Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ProfilService } from '../service';

@Component({
  selector: 'fa-kt-profil-detail',
  templateUrl: './profil-detail.component.html',
  styleUrls: ['./profil-detail.component.css'],
})
export class ProfilDetailComponent {
  $loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  @Input() set loading(loading: boolean) {
    this.$loading.next(this.$loading.getValue() || loading);
  }
  @Input() height = 'calc(100vh - 324px)';

  constructor(public profil: ProfilService) {}
}
